import React from 'react';
import { Button, Grid, Typography } from "@mui/material";
import CustomDrawer from "../../components/CustomDrawer";
import { useTranslation } from 'react-i18next';
import { dataUtil } from '../../services/wsclients/dataUtil';
import { LowFontIcon, UpFontIcon } from '../../components/CustomIcons';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
    content: {
        margin: theme.spacing(3, 0),
    },
    service: {
        padding: theme.spacing(3),
        borderRadius: theme.spacing(3),
        backgroundColor: theme.palette.common.white,
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
    },
    service_icon: {
        textAlign: 'right',
        paddingLeft: theme.spacing(2),
        // backgroundColor: theme.palette.background.primary,
    },
    service_item: {
        cursor: 'pointer'
    },
}));


export default function ChangeServicesView(props) {
    const classes = useStyles();
    const { t } = useTranslation();

    const { open, onClose, changeServices, currency, onChangeService } = props;
    let upgrade_services = changeServices && changeServices.upgrade_services ? changeServices.upgrade_services : [];
    let downgrade_services = changeServices && changeServices.downgrade_services ? changeServices.downgrade_services : [];

    return (
        <CustomDrawer
            open={open}
            title={t('services')}
            onClose={onClose}
        >
            <Grid item xs={12} className={classes.content}>
                <Grid item xs={12} container spacing={2}>
                    {upgrade_services && upgrade_services.length > 0 && upgrade_services.map((item, index) => {
                        let price = item.price ? item.price : null;
                        if(!price && item.prices && item.prices.length > 0){
                            price = item.prices[0].price;
                        }
                        if(item )
                        return (
                            <Grid item xs={12} md={6} key={index} onClick={() => props.onEstimateServices(item)} className={classes.service_item}>
                                <Grid item xs={12} className={classes.service}>
                                    <Grid item xs={12} container alignItems='center' justifyContent='center'>
                                        <Typography variant="subtitle1"><strong>{item.name ? item.name : null}</strong></Typography>
                                        <Grid item className={classes.service_icon}>
                                            <UpFontIcon />
                                        </Grid>
                                    </Grid>
                                    {/* <Grid item xs={12}>
                                        <Grid item className={classes.service_icon}>
                                            <UpFontIcon />
                                        </Grid>
                                    </Grid>
                                    <Typography variant="subtitle1"><strong>{item.name ? item.name : null}</strong></Typography> */}
                                    <Typography variant="body2">{currency}{price ? Number(price).toFixed(2) : "0.00"}</Typography>
                                </Grid>
                            </Grid>
                        );
                    })}
                </Grid>
                <Grid item xs={12} marginTop={3} container spacing={2}>
                    {downgrade_services && downgrade_services.length > 0 && downgrade_services.map((item, index) => {
                        let price = item.price ? item.price : null;
                        if(!price && item.prices && item.prices.length > 0){
                            price = item.prices[0].price;
                        }
                        return (
                            <Grid item xs={12} md={6} key={index} onClick={() => props.onEstimateServices(item)} className={classes.service_item}>
                                <Grid item xs={12} className={classes.service}>
                                    <Grid item xs={12} container alignItems='center' justifyContent='center'>
                                    <Typography variant="subtitle1"><strong>{item.name ? item.name : null}</strong></Typography>
                                        <Grid item className={classes.service_icon}>
                                            <LowFontIcon />
                                        </Grid>
                                    </Grid>
                                    {/* <Grid item justifyContent='center' alignItems='center'>
                                        <Grid item className={classes.service_icon}>
                                            <LowFontIcon style={{ width: 20, height: 20 }} />
                                        </Grid>
                                    </Grid> */}
                                    <Typography variant="body2">{currency}{price ? Number(price).toFixed(2) : "0.00"}</Typography>
                                </Grid>
                            </Grid>
                        );
                    })}
                </Grid>
            </Grid>
        </CustomDrawer>
    )
}